import React from 'react';

import ArrowButton, { ArrowLinkButtonProps } from 'Elements/Button/Arrow';

import OpenDay, { CardOpenDayProps } from 'Components/Card/OpenDay';

import { Container, Top, Heading, EventsList, ListItem } from './Horizontal.styled';

export interface Props {
    heading: string;
    events: CardOpenDayProps[];
    button?: ArrowLinkButtonProps;
}

const Horizontal: React.FC<Props> = props => {
    const { heading, events, button } = props;

    return events.length > 0 ? (
        <Container>
            <Top>
                <Heading>{heading}</Heading>
                {button && <ArrowButton {...button} variant="accentTwentyFive" />}
            </Top>
            <EventsList>
                {events.map(event => (
                    <ListItem key={event.id}>
                        <OpenDay {...event} />
                    </ListItem>
                ))}
            </EventsList>
        </Container>
    ) : null;
};

export default Horizontal;
